import {
  Modal,
  Nav,
  Tab,
  Row,
  Col,
  Image,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { BsQuestionCircle } from "react-icons/bs";
import { Score } from "@/assets/images";
import { SingleChart } from "@/pages/index";
import { TeamPerformanceTable } from "@/components/table";
import { useEffect, useState } from "react";
import { modal, table } from "@/utils/constant";

function TeamPerformanceModal({
  show,
  hide,
  gameData,
  teamName,
  singleActivityCount,
  game_complete_status
}) {
  const [activeKey, setActiveKey] = useState("first");

  const handleSelect = (key) => {
    setActiveKey(key);
  };

  useEffect(() => {
    const scrolling = document.getElementById("scroll");
    scrolling.scrollTo({ top: 0, behavior: "smooth" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey]);
  // tooltip content
  const renderTooltip = (props) => (
    <Tooltip className="tooltip-light" id="button-tooltip" {...props}>
      {modal?.teamPerformanceModalTooltip}
    </Tooltip>
  );
  const blendedScore =
    gameData?.blendedScore != null ? Number(gameData.blendedScore) : null;

  return (
    <>
      <Modal
        show={show}
        className="px-0"
        onHide={hide}
        size="xl"
        centered
        scrollable
      >
        <Modal.Header className="bg-secondary" closeButton>
          <Modal.Title>{teamName}</Modal.Title>
        </Modal.Header>
        <Modal.Body id="scroll" className="py-10 px-lg-14 chart-modal">
          <Tab.Container
            id="left-tabs-example"
            activeKey={activeKey}
            onSelect={handleSelect}
          >
            <Nav variant="pills" className="justify-content-center mb-10">
              <Nav.Item>
                <Nav.Link className="rounded-end-0 px-10" eventKey="first">
                  {table?.quality}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="rounded-0 px-10" eventKey="second">
                  {table?.financial}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="rounded-start-0 px-10" eventKey="third">
                  {table?.summary}
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="third">
                <div className="d-flex flex-column flex-xl-row gap-xl-10 gap-4 align-items-center align-items-xl-start justify-content-center justify-content-xl-start">
                  <div className="flex-shrink-0">
                    <Image src={Score} fluid style={{ maxWidth: '200px' }} />
                  </div>
                  <div className="w-100" style={{ maxWidth: '600px' }}>
                    <Row className="gx-2 gx-xl-4 justify-content-center">
                      <Col xs={12} sm={6} className="text-center mb-4 mb-sm-0">
                        <h4 className="mb-4">
                          {modal?.teamPerformanceQuality}
                        </h4>
                        <SingleChart data={gameData?.teamQualityError} name={"Quality Loss"} />
                      </Col>
                      <Col xs={12} sm={6} className="text-center">
                        <h4 className="mb-4">
                          {modal?.teamPerformanceExcess}
                        </h4>
                        <SingleChart data={gameData?.teamCost} name={"Excess Cost"} />
                      </Col>
                    </Row>
                    <hr className="d-sm-block d-none border-black border-2 border-top mt-4 mb-4" />
                    <div className="text-md font-bold d-flex align-items-center justify-content-center mt-3">
                      <OverlayTrigger
                        placement="top-start"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                      >
                        <span className="d-flex align-items-center">
                          <BsQuestionCircle className="me-2 mb-0 text-15" />
                        </span>
                      </OverlayTrigger>
                      <span>
                        {modal?.blendedScore} {blendedScore != null ? blendedScore.toFixed(2) : '—'}
                      </span>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <TeamPerformanceTable
                  gameData={gameData}
                  name="Cost"
                  singleActivityCount={singleActivityCount}
                  setActiveKey={setActiveKey}
                  game_complete_status={game_complete_status}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="first">
                <TeamPerformanceTable
                  gameData={gameData}
                  name="Error"
                  singleActivityCount={singleActivityCount}
                  setActiveKey={setActiveKey}
                  activeKey={activeKey}
                  game_complete_status={game_complete_status}
                />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default TeamPerformanceModal;
